export default __webpack_public_path__ + "static/media/mechanic-2.7302b824.jpg";